import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'reactstrap';

import './appraisal-report-toggle-btn.scss';

const SHOW_TEXT = 'Show estimated values';
const HIDE_TEXT = 'Hide estimated values';

/**
 * Renders toggle button.
 * @param {function} onClick
 * @param {boolean} show
 * @param {string} showText
 * @param {string} hideText
 * @returns {ReactElement}
 */
export function AppraisalReportToggleBtn({
  onClick,
  show = true,
  showText = SHOW_TEXT,
  hideText = HIDE_TEXT,
  btnClassNames = '',
}) {
  return (
    <Button
      color="link"
      size="lg"
      className={classNames('appraisal-report-toggle-btn w-100 text-start px-0 py-0 mt-0_5', btnClassNames)}
      onClick={onClick}
      data-tracking-id="view_detailed_report"
      aria-expanded={show}
    >
      {show ? showText : hideText}
      <span
        className={classNames('text-blue-50 align-middle size-12 ps-0_25', {
          'icon-arrow-down3': show,
          'icon-arrow-up3': !show,
        })}
        aria-hidden
      />
    </Button>
  );
}

AppraisalReportToggleBtn.propTypes = {
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool,
  showText: PropTypes.string,
  hideText: PropTypes.string,
  btnClassNames: PropTypes.string,
};
